var _line, _g, _g2, _line2, _g3, _g4, _line3, _line4, _g5, _line5, _text, _text2, _text3, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpHasRod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "640px",
    height: "610px",
    viewBox: "-0.6 0 640 610",
    enableBackground: "new -0.6 0 640 610",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 7.8,
    y1: 601.3,
    x2: 548.8,
    y2: 601.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M561.2,606.6v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1L561.2,606.6L561.2,606.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M572,606.6v-13.3h1.7v11.9h6.2v1.5H572V606.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M582.3,603.5c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5s1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9s2.4,0.3,3.5,0.9 c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9s-2.4-0.3-3.5-0.9 C583.7,605.3,582.9,604.5,582.3,603.5z M583.2,599.9c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7 s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5s-2.7,0.5-3.6,1.5 C583.7,597.1,583.2,598.4,583.2,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M597.6,603.5c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5s1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9s2.4,0.3,3.5,0.9 c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9s-2.4-0.3-3.5-0.9 C599,605.3,598.2,604.5,597.6,603.5z M598.5,599.9c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7 s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5s-2.7,0.5-3.6,1.5 C599,597.1,598.5,598.4,598.5,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M612.6,606.6v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6s-0.5,0.9-0.8,1.2 s-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H612.6z M614.3,599.8h3.5c0.8,0,1.4-0.2,1.9-0.7 s0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5L614.3,599.8L614.3,599.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 138.3,
    y: 123.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.4,
    y: 146.2,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 6.9,
    y1: 13.1,
    x2: 548,
    y2: 13.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M561.7,15.6c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4c-0.7-0.4-1.4-0.5-2.1-0.5 c-1.5,0-2.7,0.5-3.7,1.5s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5 c0.7-0.4,1.2-0.8,1.6-1.4l1.4,0.8c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.8-2.2-1.4 C562.5,17.2,562,16.5,561.7,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M575.2,19.4V6.1h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9V18h7.1v1.5h-8.7V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M586.6,19.4V6.1h1.7v13.3H586.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M591.1,19.4V6.1h1.7V18h6.2v1.5h-7.9V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M601.2,19.4V6.1h1.7v13.3H601.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M606,19.4V6.1h1.7l7.7,10.4V6.1h1.7v13.3h-1.6l-7.8-10.6v10.6H606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M620.1,15.6c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3s-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8c0.4,0.8,1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4s1.2-0.6,1.5-1v-2.7 h-4.6v-1.5h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.8-2.2-1.4 C621,17.2,620.5,16.5,620.1,15.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9481,
    x1: 488.1,
    y1: 49.9,
    x2: 66.6,
    y2: 50.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "485.5,41.1 500.8,49.9 485.5,58.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "69.2,41.3 53.9,50.1 69.2,58.9  "
  }))))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9516,
    x1: 502.8,
    y1: 34,
    x2: 502.8,
    y2: 78.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9481,
    x1: 53,
    y1: 34,
    x2: 53,
    y2: 77.3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9141,
    x1: 112.4,
    y1: 100.6,
    x2: 112.4,
    y2: 499.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "103.7,103.2 112.4,88.1 121.1,103.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "103.7,497 112.4,512.1 121.1,497  "
  }))))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 94.9,
    y1: 512.1,
    x2: 136.6,
    y2: 512.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 52.858 323.3137)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 96.0485 323.3137)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 272.2936 43.4761)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "C")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M538.4,91.5V78.1h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6s-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8s-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3H540v5.3L538.4,91.5L538.4,91.5z M540,84.7h3.5 c0.8,0,1.4-0.2,1.9-0.7s0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7H540V84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M550.8,88.3c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5s1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9s2.4,0.3,3.5,0.9 s1.8,1.4,2.4,2.5c0.6,1,0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5c-0.6,1-1.3,1.9-2.4,2.5s-2.2,0.9-3.5,0.9s-2.4-0.3-3.5-0.9 S551.4,89.4,550.8,88.3z M551.7,84.8c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7s1.8-0.2,2.6-0.7 s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9s-2.1-1.5-3.6-1.5s-2.7,0.5-3.6,1.5S551.7,83.2,551.7,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M565.9,91.5V78.1h4.6c1.4,0,2.6,0.3,3.6,0.9s1.8,1.4,2.4,2.4s0.8,2.1,0.8,3.4c0,0.9-0.2,1.8-0.5,2.6 s-0.8,1.5-1.4,2.1s-1.3,1.1-2.2,1.4s-1.8,0.5-2.8,0.5L565.9,91.5L565.9,91.5z M567.5,90h2.9c1,0,2-0.2,2.8-0.7s1.4-1.1,1.8-1.9 s0.6-1.6,0.6-2.6s-0.2-1.9-0.6-2.6s-1-1.4-1.8-1.9s-1.7-0.7-2.8-0.7h-2.9V90z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 82.2,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.6525,
    width: 450.6,
    height: 5.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 502.1,
    y: 79.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 79.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9154,
    x1: 71,
    y1: 100.6,
    x2: 71,
    y2: 589.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "62.3,103.2 71,88.1 79.7,103.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "62.3,586.9 71,602 79.7,586.9  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpHasRod);
export default __webpack_public_path__ + "static/media/help_hasRod.132e8138b62c1d321cb241b968ac76f4.svg";
export { ForwardRef as ReactComponent };